export const translationConfig = {
  common: ['CommonUI.Features', 'CommonUI.Messages', 'Common.AlertsAndOptions', 'Common.Presence'],
  feature: 'Feature.ShopDialog'
};
export const redeemTranslationConfig = {
  common: ['CommonUI.Features', 'Common.AlertsAndOptions'],
  feature: 'Purchasing.RedeemGameCard'
};
export default translationConfig;
